import {Actions} from "documents/actions";
import {IDocument, IDocUploadBody} from "StateInterface";
import {DocTypes} from "userform/utils";
export interface IState {
    documents: IDocument[];
    fetchAllInfo: boolean;
    active: boolean;
    documentUploaded: boolean;
    docUploadError: {docType: string; error: string};
}
import {dateFormat} from "userform/utils";
import {KycDocUploadEvent, updateDocumentEvent} from "documents/event";
import {EventName, updateConsentEvent} from "consent/events";

export const defaultState = {
    documents: [],
    fetchAllInfo: false,
    active: false,
    documentUploaded: false,
    docUploadError: null,
};

export default function documents(state= defaultState, action) {
    switch (action.type) {
    case Actions.REQUEST_DOCUMENTS:
      return {
        ...state,
        active: true,
      };
    case `${Actions.REQUEST_SAVE_DOCUMENT}_SUCCESS`:
        updateEvents(action.payload.extra.docType, true, action.payload.extra?.docSubType);
        const docTemp = [...state.documents];
        const doc = state.documents.filter((d) => d !== null && d.type === action.payload.extra.docType);
        const docIndex = state.documents.indexOf(doc[0]);
        const docitem = {
        type: action.payload.extra.docType,
        image: action.payload.service.body.content,
        date: new Date(),
      };
        if (docIndex === -1) {
        docTemp.push(docitem);
      } else {
        docTemp[docIndex] = docitem;
      }
        return {
        ...state,
        documents: docTemp,
        active: false,
        documentUploaded: true,
      };
    case `${Actions.REQUEST_SAVE_DOCUMENT}_FAILURE`:
      updateEvents(action.payload.extra.docType, false);
      return {
          ...state,
          documentUploaded: false,
          active: false,
          docUploadError: {
            docType: action.payload.extra.docType,
            error: action.body && action.body.err,
          },
      };
    case Actions.REQUEST_SAVE_DOCUMENT:
      return {
        ...state,
        active: true,
        documentUploaded: false,
        docUploadError: null,
      };
    case Actions.CLEAR_DOC_UPLOAD_ERROR:
      return {
        ...state,
        docUploadError: null,
      };
    case `${Actions.REQUEST_DOCUMENTS}_SUCCESS`:
      action.body.map((document) => document.date = new Date(document.date));
      return {
        ...state,
        documents: action.body,
        fetchAllInfo: false,
        active: false,
        docUploadError: null,
      };
      case Actions.SET_DOCUMENT_UPLOAD_STATUS:
        return {
            ...state,
            documentUploaded: false,
        };
      case `${Actions.REQUEST_DOCUMENTS}_FAILURE`:
      return {
        ...state,
        fetchAllInfo: false,
      };
      case Actions.SET_PREFILL_DOCS:
          return {
              ...state,
              documents: action.body,
          };
    default:
      return state;
    }
}

const updateEvents = (type: DocTypes, isSuccess: boolean, subDocName?: string) => {
  if (type === DocTypes.NACH) {
    updateConsentEvent(EventName.SCAN_AND_UPLOAD_NACH, isSuccess);
  } else if (type === DocTypes.CURRENT_ADDRESS_PROOF) {
    KycDocUploadEvent(type, subDocName, isSuccess);
  } else {
    updateDocumentEvent(type, isSuccess);
  }
};
